import * as Website from '../../Config/Website.js';
import Interview from '../../Modules/Interview.js';
import Fv from '../../Modules/Fv.js';


const preinit = () => {

}

const init = () => {
  Interview();
  Fv();
}

const resize = () => {

}

const resizeW = () => {

}

const scroll = () => {

}

const load = () => {

}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}